import { i18n } from '@/i18n';
import { onboardingUrlRegExp } from '@/rules/regexp/URL';
import { FormKitRule } from '@/types/interfaces/ValidationRule.interface';

/** @deprecated Should export just FormKitPattern. Rule part should be removed, use 'matches' with imported regex instead. */
export const WebsiteFormKitRule: FormKitRule = {
  name: 'website',
  rule: (node) => typeof node.value === 'string' && onboardingUrlRegExp.expression.test(node.value),
  message: ({ name }) => i18n.global.t('validation.invalid_field', [name]),
};
